import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/messages.css";
import pic from "../images/hello.png";
import api from "./api";
import chat from "../images/chat.png";

const Messages = () => {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [markingSeen, setMarkingSeen] = useState({}); // برای tracking وضعیت هر تیکت

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("fa-IR", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const goBack = () => {
    navigate(-1);
  };

  // تابع mark as seen
  const markTicketAsSeen = async (ticketId) => {
    try {
      // جلوگیری از ارسال همزمان چند درخواست برای یک تیکت
      if (markingSeen[ticketId]) return;

      setMarkingSeen(prev => ({ ...prev, [ticketId]: true }));

      const response = await api.post(`/pre_student/api/v3/student-mark-seen/${ticketId}/`);

      if (response.status === 200) {
        setTickets(prevTickets =>
          prevTickets.map(ticket =>
            ticket.id === ticketId
              ? { ...ticket, unread_count: 0 }
              : ticket
          )
        );
      }
    } catch (err) {
      console.error("خطا در Mark as seen:", err);
      // در صورت خطا، می‌توانید خطا را نمایش دهید یا نادیده بگیرید
    } finally {
      setMarkingSeen(prev => ({ ...prev, [ticketId]: false }));
    }
  };

  // دریافت لیست تیکت‌ها از API
  useEffect(() => {
    const fetchTickets = async () => {
      try {
        setLoading(true);
        const response = await api.get(
          "/pre_student/api/v3/student-ticket-list/"
        );
        if (response.data && response.data.tickets) {
          setTickets(response.data.tickets);
        }
      } catch (err) {
        console.error("خطا در دریافت پیام‌ها:", err);
        setError("مشکلی در دریافت پیام‌ها وجود دارد.");
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, []);

  // تابع رفتن به صفحه جزئیات تیکت با مارک سین
  const handleTicketClick = async (ticketId) => {
    // اگر تیکت پیام نخوانده دارد، ابتدا مارک سین می‌زنیم
    const ticket = tickets.find(t => t.id === ticketId);
    if (ticket && ticket.unread_count > 0) {
      await markTicketAsSeen(ticketId);
    }

    // سپس ناوبری به صفحه جزئیات
    navigate(`/message-detail/${ticketId}`);
  };

  if (loading) {
    return (
      <div className="p-lg-5 px-0 py-3 text-center">
        <div>در حال بارگذاری پیام‌ها...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-lg-5 px-0 py-3 text-center">
        <div className="text-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="p-lg-5 px-0 py-3">
      <div className="d-flex justify-content-between">
        <div className="fs-5 fs-lg-4">
          <img src={chat} width={60} className="mx-3" alt="chat" />
          پیام های من
        </div>
      </div>
      <div className="about-course m-lg-5 mx-3 my-4">
        <div className="coursed-container">
          {tickets.length === 0 ? (
            <div className="text-center py-5">هیچ پیامی وجود ندارد</div>
          ) : (
            tickets.map((ticket) => (
              <div
                key={ticket.id}
                className="p-lg-2 p-0 d-flex bb-detail justify-content-between"
                style={{ cursor: "pointer" }}
                onClick={() => handleTicketClick(ticket.id)}
              >
                <div className="d-flex my-3">
                  <div className="number-part me-2">
                    <img
                      className="rounded-circle"
                      src={ticket.teacher_profile_image ? `${ticket.teacher_profile_image}` : pic}
                      width={46}
                      height={46}
                      alt="پروفایل"
                    />
                  </div>
                  <div className="px-lg-4 px-1 wc-200">
                    <div className="fw-bold">{ticket.package_title}</div>
                    <div className="d-flex justify-content-between">
                      <div className="fs-little mt-lg-3 mb-lg-2 mb-0 mt-1 text-muted">
                        {ticket.last_message || "بدون پیام"}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex ms-3 align-items-center">
                  <div>
                    {ticket.unread_count > 0 && (
                      <span className="rounded-circle unread-msg">
                        {ticket.unread_count}
                      </span>
                    )}
                    <div className="mt-1 fs-little">
                      {formatDate(ticket.last_message_created_at)}
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Messages;